import React from 'react';
import {
  createStyles,
  makeStyles,
  Grid,
} from '@material-ui/core';
import MainBarLink from './MainBarLink';
import logo from '../../assets/img/ph/logo-text-white.svg';
import MainBarDropdown from './MainBarDropdown';
import MainBarDropdownLink from './MainBarDropdownLink';
import MainBarUserMenu from './MainBarUserMenu/MainBarUserMenu';
import { useGuard } from '../../hooks';
import { is, roles } from '../../utility/guard';
import { ExtendedTheme } from '../../theme';

const useStyles = makeStyles(({ palette, container }: ExtendedTheme) => createStyles({
  root: {
    maxWidth: container,
    alignItems: 'stretch',
  },
  logo: {
    width: '120px',
    height: '40px',
  },
  grow: {
    flexGrow: 1,
  },
}), { name: 'MainBarContentLg' });

const MainBarContentLg = () => {
  const classes = useStyles();

  const isAdmin = useGuard(is(roles.superAdmin));
  const developmentMode = process.env.REACT_APP_BUILD_ENV === 'development';

  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid component={MainBarLink} to="/dashboard" item xs={2}>
        <img src={logo} alt="logo" className={classes.logo} />
      </Grid>
      <Grid component={MainBarLink} to="/dashboard/projects" item>
        ClipPress
      </Grid>
      {isAdmin && (
        <Grid
          component={MainBarDropdown}
          title="Admin"
          to="/dashboard/admin/*"
          item
        >
          <MainBarDropdownLink to="/dashboard/admin/users">
            Users
          </MainBarDropdownLink>
          <MainBarDropdownLink to="/dashboard/admin/organizations">
            Organizations
          </MainBarDropdownLink>
          {
            (
              !developmentMode ? null :
                <MainBarDropdownLink to="/dashboard/admin/orders">
                  Orders
                </MainBarDropdownLink>
            )
          }
          <MainBarDropdownLink to="/dashboard/admin/promotion-codes">
            Promotion Codes
          </MainBarDropdownLink>
          <MainBarDropdownLink to="/dashboard/admin/customers">
            Customers
          </MainBarDropdownLink>
          <MainBarDropdownLink to="/dashboard/admin/videos">
            Videos
          </MainBarDropdownLink>
          <MainBarDropdownLink to="/dashboard/admin/video-menus">
            Video menu
          </MainBarDropdownLink>
        </Grid>
      )}
      <Grid item xs className={classes.grow} />
      <Grid item>
        <MainBarUserMenu />
      </Grid>
    </Grid>
  );
};

export default MainBarContentLg;
